<template>
  <div class="main-content-container bg--light">
    <div class="top-content-container position-relative">
      <b-breadcrumb class="pb-2">
        <b-breadcrumb-item>
          <span
            class="text-uppercase font-family-medium"
            @click="$router.push({ name: 'DedicatedCustomers' })"
            >Customers</span
          >
        </b-breadcrumb-item>
      </b-breadcrumb>
      <h1 class="font-lg font-family-medium primary-dark content-title">
        Archived
      </h1>

      <div
        v-if="loaded && customersList.length"
        class="position-absolute grid-icon-container"
      >
        <img
          v-if="!showListView"
          @click="showListView = !showListView"
          src="@/assets/icons/card_grid.svg"
          alt
          class="cursor-pointer"
        />
        <img
          v-if="showListView"
          @click="showListView = !showListView"
          src="@/assets/icons/card_list.svg"
          alt
          class="cursor-pointer"
        />
      </div>
      <b-dropdown-divider class="mb-5 mt-3 " />
    </div>

    <!-- Start grid view assistants -->
    <div v-if="!showListView" class="d-flex grid-card-wrapper">
      <b-row class="w-100 d-flex flex-column" no-gutters>
        <b-row class="">
          <b-col
            cols="6"
            md="4"
            lg="4"
            xl="3"
            v-for="customer in customersList"
            :key="customer.id"
          >
            <b-card
              no-body
              @click="navigate(customer.customer.profile)"
              @mouseenter="showCardHover(customer.customer.profile.id)"
              @mouseleave="undoCardHover(customer.customer.profile.id)"
              class="grid-card mb-5 p-3"
            >
              <div class="d-flex justify-content-end">
                <div class="d-flex">
                  <div
                    v-if="
                      !archiveHover ||
                        (showInactiveArchiveHover &&
                          activeArchiveHoverId !== customer.customer.profile.id)
                    "
                    class="empty-icon-avatar d-flex align-items-center justify-content-center"
                  >
                    <img
                      class="cursor-pointer"
                      @click.stop="showArchiveModal(customer.customer.profile)"
                      src="@/assets/icons/arrow_down_square.svg"
                      alt
                    />
                  </div>
                  <div
                    class="archive-hover-avatar position-relative d-flex align-items-center justify-content-center"
                    v-if="
                      archiveHover &&
                        activeArchiveHoverId === customer.customer.profile.id
                    "
                    @click.stop="showArchiveModal(customer.customer.profile)"
                  >
                    <img
                      src="@/assets/icons/arrow_down_square_hover.svg"
                      alt=""
                    />
                  </div>
                </div>
                <!-- <img src="@/assets/icons/arrow_down_square.svg" alt /> -->
              </div>
              <b-card-body class="text-center grid-card-body position-relative">
                <b-button
                  v-if="!customer.customer.profile.isProfileIntakeSubmitted"
                  class="btn-danger btn-pill notification-btn-grid btn-align-top position-absolute"
                  >New</b-button
                >
                <b-avatar
                  class="customers-grid-avatar"
                  v-if="customer.customer.profile.user.avatarThumbnail"
                  size="12rem"
                  :src="customer.customer.profile.user.avatarThumbnail"
                ></b-avatar>
                <b-avatar
                  class="bg--primary customers-grid-avatar"
                  v-else
                  size="12rem"
                  :text="
                    getInitials(`
                    ${customer.customer.profile.user.firstName} ${customer.customer.profile.user.firstName}`)
                  "
                ></b-avatar>
                <p class="font-family-medium primary--text mt-4" :title="`${customer.customer.profile.user.firstName} ${customer.customer.profile.user.lastName}`">
                  {{
                    ellipsify(`${customer.customer.profile.user.firstName} ${customer.customer.profile.user.lastName}`, 25)
                  }}
                </p>
                <div class="d-flex justify-content-center reduce-whitespace-2">
                  <b-button
                    class="text-uppercase mr-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                    >{{
                      customer.customer.profile.customerProfile.membership
                    }}</b-button
                  >
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <infinite-loading
          spinner="spiral"
          @infinite="infiniteHandlerArchivedCustomers"
          :identifier="infiniteId"
          ><div slot="no-more">
            <h4 class="primary--text font-family-medium mb-5 mt-5">
              No more customers to load.
            </h4>
          </div>
          <div slot="no-results">
            <h4 class="primary--text font-family-medium mb-5 mt-5">
              No more customers to load.
            </h4>
          </div></infinite-loading
        >
      </b-row>
    </div>

    <div
      class="no-assigned-msg pr-5 pt-5 pb-5 pl-2 d-flex flex-column justify-content-center align-items-center"
      v-if="customersList.length === 0 && !isLoadingCustomers"
    >
      <h4 class="font-md primary--text font-family-medium">
        No customers archived yet
      </h4>
    </div>

    <!-- Show list view assistants -->
    <b-row v-if="showListView" no-gutters>
      <b-col cols="12" xl="6">
        <b-row class="w-100 mx-0 justify-content-between py-0 heading-row">
          <h6
            class="font-sm position-relative primary--text font-family-medium"
          >
            Customer
          </h6>
          <h6 
            class="font-sm position-relative primary--text font-family-medium actions-1"
          >
            Actions
          </h6>
        </b-row>
      </b-col>
      <b-col cols="6">
        <b-row
          v-if="customersList.length > 1"
          class="w-100 mx-0 justify-content-between py-0 heading-row second-heading-row" 
        >
          <h6 :style="{paddingLeft:'15px'}"
            class="font-sm position-relative primary--text font-family-medium"
          >
            Customer
          </h6>
          <h6
            class="font-sm position-relative primary--text font-family-medium"
          >
            Actions
          </h6>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="showListView" class="mb-4" >
      <b-col
        class="grid-list-column"
        md="12"
        xl="6"
        lg="12"
        sm="12"
        cols="12"
        v-for="customer in customersList"
        :key="customer.id"
      >
        <b-card
          @mouseleave="undoCardHover(customer.customer.profile.id)"
          @mouseenter="showCardHover(customer.customer.profile.id)"
          @click="navigate(customer.customer.profile)"
          class="grid-list-card mt-5 px-0"
          no-body
        >
          <b-card-body class="d-flex text-center grid-list-card-body py-4 px-0">
            <b-col md="6" xl="7" sm="7" cols="8" class="d-flex pr-0">
              <div>
                <b-avatar
                  v-if="customer.customer.profile.user.avatarThumbnail"
                  class="customers-grid-avatar"
                  size="8rem"
                  :src="customer.customer.profile.user.avatarThumbnail"
                ></b-avatar>
                <b-avatar
                  size="8rem"
                  v-else
                  class="customers-grid-avatar bg--primary"
                  :text="
                    getInitials(
                      `${customer.customer.profile.user.firstName} ${customer.customer.profile.user.lastName}`
                    )
                  "
                ></b-avatar>
              </div>
              <div
                class="d-flex flex-column align-items-start justify-content-center ml-4"
              >
                <p class="font-family-medium primary--text">
                  {{
                    `${customer.customer.profile.user.firstName} ${customer.customer.profile.user.lastName}`
                  }}
                </p>
                <!-- <p class="secondary--text customer-email reduce-whitespace">
                  {{
                    `${customer.customer.profile.user.email.substring(
                      0,
                      15
                    )}...`
                  }}
                </p> -->
                <div class="d-flex justify-content-center">
                  <b-button
                    class="text-uppercase mr-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                    >{{
                      customer.customer.profile.customerProfile.membership
                    }}</b-button
                  >
                </div>
              </div>
            </b-col>
            <div class="notification-btn-list-container my-4 mr-5">
              <b-button
                v-if="!customer.customer.profile.isProfileIntakeSubmitted"
                class="btn-danger btn-pill notification-btn-grid"
                >New</b-button
              >
            </div>
            <div
              class="ml-5 d-flex position-absolute grid-list-action-icons align-items-center"
            >
              <div
                class="empty-icon-avatar d-flex align-items-center justify-content-center"
              >
                <img
                  v-if="
                    !archiveHover ||
                      (showInactiveArchiveHover &&
                        activeArchiveHoverId !== customer.customer.profile.id)
                  "
                  @click.stop="showArchiveModal(customer.customer.profile)"
                  class="mr-5 cursor-pointer"
                  src="@/assets/icons/arrow_down_square.svg"
                  alt
                />
              </div>
              <div
                class="archive-hover-avatar archive-right position-absolute d-flex align-items-center justify-content-center"
                v-if="
                  archiveHover &&
                    activeArchiveHoverId === customer.customer.profile.id
                "
                @click.stop="showArchiveModal(customer.customer.profile)"
              >
                <img src="@/assets/icons/arrow_down_square_hover.svg" alt="" />
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <infinite-loading
        spinner="spiral"
        style="width:100%"
        @infinite="infiniteHandlerArchivedCustomers"
        :identifier="infiniteId"
        ><div slot="no-more">
          <h4 class="primary--text font-family-medium mb-5 mt-5">
            No more customers to load.
          </h4>
        </div>
        <div slot="no-results">
          <h4 class="primary--text font-family-medium mb-5 mt-5">
            No more customers to load.
          </h4>
        </div></infinite-loading
      >
    </b-row>
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="showArchive"
      v-if="showArchive"
    >
      <b-container fluid>
        <b-button
          @click="closeModal"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row class="pt-2 pl-4 d-flex flex-column">
          <h2 v-if="isCustomerUnarchived" class="font-md modal_header ml-4">
            Successfully unarchived
          </h2>
          <h4
            v-if="!isCustomerUnarchived"
            class="font-md subtext mb-4 mt-3 ml-4"
          >
            Do you want to unarchive the following profile?
          </h4>
          <h4 v-else class="font-md subtext mb-4 mt-1 ml-4">
            Following customer has been successfully unarchived.
          </h4>
        </b-row>
        <b-row align-v="center" class="pr-2">
          <b-col class="flex-row d-flex mb-4 ml-4">
            <div>
              <b-avatar
                v-if="selectedCustomerAvatar"
                :src="selectedCustomerAvatar"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
              <b-avatar
                v-else
                :text="selectedCustomerInitials"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
            </div>
            <div class="d-flex flex-column position-relative ml-4">
              <p class="font-family-medium primary--text">
                {{ selectedCustomerFullName }}
              </p>
              <!-- <p class="secondary--text reduce-whitespace">
                {{ selectedCustomerEmail }}
              </p> -->
              <div class="d-flex reduce-whitespace-2">
                <b-button
                  class="text-uppercase btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                  >{{ selectedSub }}</b-button
                >
              </div>
            </div>
          </b-col>
          <b-button
            @click="unarchiveCustomer"
            v-if="!isCustomerUnarchived"
            class="btn-primary px-5 py-3 btn-pill reduce-whitespace mr-5"
          >
            <b-spinner
              v-if="isSavingUnarchive"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${isSavingUnarchive ? "" : unarchiveBtnText}` }}
          </b-button>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  getAllArchivedOrDeletedAccounts,
  getAssistantCustomers,
  unarchiveCustomerAccount
} from "@/apis/customers";
import { internalCustomerEmailSet } from "@/utils/constants";
import { getInitials, ellipsify } from "@/utils/utils";
export default {
  name: "PAArchivedCustomers",
  methods: {
    getInitials,
    ellipsify,
    navigate(customer) {
      if (customer.isProfileIntakeSubmitted) {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: customer.id
          },
          query: {
            tab: 2
          }
        });
      } else {
        this.$router.push({
          name: "ClientIntake",
          params: {
            profileId: customer.id
          }
        });
      }
    },
    showCardHover(id) {
      this.activeExpandHoverId = id;
      this.expandHover = true;
      this.showInactiveExpandHover = true;
      this.activeArchiveHoverId = id;
      this.archiveHover = true;
      this.showInactiveArchiveHover = true;
    },
    undoCardHover(id) {
      this.inactiveExpandHoverId = id;
      this.expandHover = false;
      this.inactiveArchiveHoverId = id;
      this.archiveHover = false;
    },
    showArchiveModal(profile) {
      let { user, customerProfile } = profile;
      this.selectedCustomerFullName = `${user.firstName} ${user.lastName}`;
      this.selectedSub = customerProfile.membership;
      this.selectedCustomerInitials = this.selectedCustomerFullName
        .match(/\b(\w)/g)
        .join("");
      this.showArchive = true;
      this.selectedCustomerEmail = user.email;
      this.selectedCustomerAvatar = user.avatarThumbnail;
      this.getArchivedAccounts();
    },

    infiniteHandlerArchivedCustomers($state) {
      const params = {
        limit: 30,
        offset: this.offset,
        customer__is_active: false
      };
      getAssistantCustomers(this.profileUserId, params).then(res => {
        this.loaded = true;
        this.customersList = [
          ...this.customersList,
          ...res.data.results
        ].filter(
          el => !internalCustomerEmailSet.has(el.customer.profile.user.email)
        );
        this.offset = res.data.offset;
        if (res.data.next === null) {
          $state.complete();
        } else {
          $state.loaded();
        }
      });
    },
    getArchivedAccounts() {
      getAllArchivedOrDeletedAccounts().then(res => {
        let getArchiveDeleteForCurrentProfile = res.data.results.filter(
          item => item.profile === this.activeArchiveHoverId
        );
        if (getArchiveDeleteForCurrentProfile.length > 0) {
          this.customerIdToUnarchive = getArchiveDeleteForCurrentProfile[0].id;
          this.isDelete = res.data.results
            .filter(item => {
              if (
                item.profile === this.activeArchiveHoverId &&
                !item.isDelete
              ) {
                return (
                  item.profile === this.activeArchiveHoverId &&
                  item.isDelete === false
                );
              }
            })
            .map(i => i.isDelete)[0];
        }
      });
    },
    unarchiveCustomer() {
      this.isSavingUnarchive = true;
      unarchiveCustomerAccount(this.customerIdToUnarchive)
        .then(() => {
          this.isCustomerUnarchived = true;
          this.isSavingUnarchive = false;
          this.customersList = this.customersList.filter(
            item => item.customer.profile.id !== this.activeArchiveHoverId
          );
          this.getArchivedAccounts();
        })
        .catch(err => {
          this.isSavingUnarchive = false;
          console.log(err);
        });
    },
    closeModal() {
      this.showArchive = false;
      this.isCustomerUnarchived = false;
    }
  },
  computed: {
    ...mapState("authModule", ["role", "profileUserId"])
  },
  data() {
    return {
      count: null,
      selectedSub: "",
      isLoadingCustomers: true,
      infiniteId: +new Date(),
      offset: 0,
      loaded: false,
      showListView: false,
      isDedicated: false,
      isHandover: false,
      customersList: [],
      assistantProfileId: "",
      expandHover: false,
      archiveHover: false,
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      activeArchiveHoverId: "",
      inactiveArchiveHoverId: "",
      showInactiveArchiveHover: true,
      showArchive: false,
      selectedCustomerFullName: "",
      selectedCustomerEmail: "",
      selectedCustomerAvatar: "",
      selectedCustomerInitials: "",
      isSavingUnarchive: false,
      isCustomerUnarchived: false,
      archiveBtnText: "Archive",
      unarchiveBtnText: "Unarchive",
      customerIdToUnarchive: "",
      isDelete: null
    };
  }
};
</script>

<style lang="scss" scoped>
.grid-list-wrapper {
}
.grid-list-card {
}
.grid-card:not(:last-child) {
  margin-right: 2%;
}
.grid-card:last-child {
  margin-right: 0;
}
.grid-icon-container {
  right: 0;
  bottom: 30%;
}
.grid-icon-container img {
  width: 21px;
  height: 21px;
}
.grid-list-action-icons {
  margin-top: -1.5rem;
  top: 40%;
  right: 0;
}
.grid-list-action-icons-hover {
  top: 40%;
  right: 5%;
}
.grid-card-action-icons {
  // top: 5%;
  right: 0;
}
.expand-right {
  right: 1.5rem;
}
.archive-right {
  right: 1.5rem;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.btn-align-top {
  top: -3.5rem;
}
.align-avatar-right {
  right: 1.3rem;
  bottom: 1rem;
}
.card {
  cursor: pointer;
}
.heading-row {
  padding-left: 15px;
  padding-right: calc(15px);
}
@media (max-width: 1199px) {
  .second-heading-row {
    display: none;
  }
}
@media (min-width: 1200px) {
  .actions-1 {
    padding-right: 15px;
  }
}
</style>
